import type { Batch } from '../BatchTracking/types';

const MINUTE_MS = 60_000;

/** Whole minutes left to change the batch, rounded up; 0 once `editableUntil` is null or past. The server decides on its own clock. */
export const minutesLeft = ({ editableUntil }: Batch, now: Date): number =>
  editableUntil ? Math.max(0, Math.ceil((Date.parse(editableUntil) - now.getTime()) / MINUTE_MS)) : 0;

export const isEditable = (batch: Batch, now: Date): boolean => minutesLeft(batch, now) > 0;
